// extracted by mini-css-extract-plugin
export var dataCell = "_r8-2";
export var dataRow = "_r8-0";
export var headerRow = "_r8-1";